import * as React from 'react';
import { Basis, ReportActions } from 'redux/ducks/reportFilter';
import FoodWasteOverview from './FoodWasteOverview';
import { connect } from 'react-redux';
import * as reportsDispatch from 'redux/ducks/reportFilter';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type FoodWasteOverviewContainerProps = DispatchProps & StateProps;

const FoodWasteOverviewContainer: React.FunctionComponent<FoodWasteOverviewContainerProps> = (
  props
) => {
  const { setBasis, basis } = props;

  const handleTabChange = (basis: Basis) => {
    setBasis(basis);
  };

  return <FoodWasteOverview basis={basis} onTabChange={handleTabChange} />;
};

const mapStateToProps = (state: RootState) => ({
  basis: state.reportFilter.basis
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, ReportActions>) => ({
  setBasis: (basis: Basis) => dispatch(reportsDispatch.changeBasis(basis))
});

export default connect<StateProps, unknown, unknown>(
  mapStateToProps,
  mapDispatchToProps
)(FoodWasteOverviewContainer);
